import { isNewRelicEnabled } from './newRelicConfig';
import { pathnameToRoutePattern } from './pathnameToRoutePattern';
import { getObservabilityRoutePatterns } from './routePatterns';

const routePatterns = getObservabilityRoutePatterns();

export function reportNewRelicError(error, context) {
  if (!isNewRelicEnabled()) return;

  const nr = window.newrelic;
  if (!nr?.noticeError) return;

  const err = error instanceof Error ? error : new Error(String(error));
  const attrs = context ? { ...context } : undefined;
  if (attrs && typeof attrs.route === 'string') {
    attrs.route = pathnameToRoutePattern(attrs.route, routePatterns);
  }
  nr.noticeError(err, attrs);
}
